import config from '../../../package.json';

// 1、window.localStorage 浏览器永久缓存
export const Local = {
	// 查看 v2.4.3版本更新日志
	setKey(key) {
		// @ts-ignore
		return `${config.name}:${key}`;
	},
	// 设置永久缓存
	set(key, val) {
		window.localStorage.setItem(Local.setKey(key), JSON.stringify(val));
	},
	// 获取永久缓存
	get(key) {
		let json = window.localStorage.getItem(Local.setKey(key));
		return JSON.parse(json);
	},
	// 移除永久缓存
	remove(key) {
		window.localStorage.removeItem(Local.setKey(key));
	},
	// 移除全部永久缓存
	clear() {
		window.localStorage.clear();
	},
};

// 2、window.sessionStorage 浏览器临时缓存
export const Session = {
	// 设置临时缓存
	set(key, val) {
		window.sessionStorage.setItem(Local.setKey(key), JSON.stringify(val));
	},
	// 获取临时缓存
	get(key) {
		let json = window.sessionStorage.getItem(Local.setKey(key));
		return JSON.parse(json);
	},
	// 移除临时缓存
	remove(key) {
		window.sessionStorage.removeItem(Local.setKey(key));
	},
	// 移除全部临时缓存
	clear() {
		window.sessionStorage.clear();
	},
};


/**
 * 获取连接地址参数
 * @Author   lyj
 * @DateTime 2019-03-01T17:47:56+0800
 * @param    {{描述}}
 * @param    {[type]}                 e [description]
 * @return   {[type]}                   [description]
 */
export const getQueryString = e => {
    var t = new RegExp("(^|&)" + e + "=([^&]*)(&|$)");
    var a = window.location.search.substr(1).match(t);
    if (a != null) return a[2];
    return ""
};
/**
 * 获取当前年月日
 */
export const getCurrentDate = () => {
  const date = new Date()
  const y = date.getFullYear()
  const m = date.getMonth() + 1
  const day = date.getDate()
  return y + '-' + m + '-' + day
}

/**
 * 生成 UUID
 */
 export const UUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * 字符串是否含有html标签的检测
 * @param htmlStr
 */
export const checkHtml = (htmlStr) => {
  var  reg = /<[^>]+>/g;
  return reg.test(htmlStr);
}

/**
 * 深拷贝
 */
export const deepClone = (obj, hash = new WeakMap()) => {
  if(typeof obj !== 'object'){
    return false
  }
  if(hash.has(obj)) return hash.get(obj)
  let o = Array.isArray(obj) ? [] : {}
  let C = obj.constructor
  if(obj && typeof obj === 'object'){
    switch(C){
      case Date:
        o = new C(obj)
        break;
      case RegExp:
        o = new C(obj)
        break;
      default:
    }
    for(let p in obj){
      if(obj.hasOwnProperty(p)){
        hash.set(obj,o)
        if(obj[p] && typeof obj[p] === 'object'){
          o[p] = deepClone(obj[p], hash)
        }else{
          o[p] = obj[p]
        }
      }
    }
  }
  return o
}

// -----------精度计算----------------
// --- 加法 ---
export const add = (num1, num2) => {
  let r1, r2, m;
  try{
    r1 = num1.toString().split('.')[1].length
  }catch(e){
    r1 = 0
  }
  try{
    r2 = num2.toString().split('.')[1].length
  }catch(e){
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (num1 * m + num2 * m) / m
}

// --- 减法 ---
export const sub = (num1, num2) => {
  let r1, r2, m, n;
  try{
    r1 = num1.toString().split('.')[1].length
  }catch(e){
    r1 = 0
  }
  try{
    r2 = num2.toString().split('.')[1].length
  }catch(e){
    r2 = 0
  }
  n = Math.max(r1, r2)
  m = Math.pow(10, n)
  return Number(((num1 * m - num2 * m) / m).toFixed(n))
}

// --- 乘法 ---
export const multiply = (num1, num2) => {
  let m = 0,
  s1 = num1.toString(),
  s2 = num2.toString()
  try {
    m += s1.split('.')[1].length
  }catch(e){}
  try {
    m += s2.split('.')[1].length
  }catch(e){}
  return Number(s1.replace('.','')) * Number(s2.replace('.','')) / Math.pow(10,m)
}

// --- 除法 ---
export const divide = (num1, num2) => {
  let t1,t2,r1,r2;
  try {
    t1 = num1.toString().split('.')[1].length
  }catch(e){
    t1 = 0
  }
  try {
    t2 = num2.toString().split('.')[1].length
  }catch(e){
    t2 = 0
  }
  r1 = Number(num1.toString().replace('.',''))
  r2 = Number(num2.toString().replace('.',''))
  return (r1 / r2) * Math.pow(10, t2 - t1)
}